import React from 'react';

function App(props) {

  var rows = props.rows;
  return <table style={{width:'100%',borderCollapse:'collapse'}}><tbody>{rows}</tbody></table>    
}

export default App;
